import { useMemo } from 'react';
import Api from '../../services/api/api';
import AppContext from './AppContext';
import useGlobalStyles from './styles';

function AppContainer({ children }: ContainerProps) {
  useGlobalStyles();

  const contextValue = useMemo(
    () => ({
      api: new Api(),
    }),
    []
  );

  return <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>;
}

export default AppContainer;
